<lcs-loading-overlay [show]="callState | lcsCallState: 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">Add Existing Prompt</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
   </div>
   <form [formGroup]="form" (ngSubmit)="onCreate()">
      <mat-dialog-content>
         <mat-form-field>
            <mat-label>Prompt</mat-label>
            <input
               [lcsSingleSelect]="promptSelect"
               [accountId]="accountId"
               [promptTypesToInclude]="promptTypesToInclude ?? [1]"
               ndtPromptSelect
               type="text"
               formControlName="prompt"
               [name]="'prompt'"
               required
            />
            <ndt-prompt-select #promptSelect [isIncludeEmptyOption]="true"></ndt-prompt-select>
         </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="submit" title="Create" mat-raised-button>Save</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
